var Application = {
    init: function() {
        this.initMenuToggle();
        this.initToTopButton();
        this.initPopupToggle();
        this.initJsLettering();
        this.initAnimateScroll();
        this.initDatepicker();
        this.initInputs();
        this.initMainEventBanner();
    },
    initMenuToggle: function() {
        $('[data-toggle="main-menu"]').click(function(e) {
            e.preventDefault();
            $('body').toggleClass('menu-opened');
        });
    },
    initToTopButton: function () {
        $('[data-toggle="to-top"]').click(function (e) {
            e.preventDefault();
            Application.animateToOffset(0, 300);
        });
    },
    initJsLettering: function() {
      $('[data-toggle="lettering"]').lettering('letters');
    },
    initPopupToggle: function () {
        $(document).on('click', '[data-toggle="popup"]', function (e) {
            e.preventDefault();

            var target = $(this).data('target'),
                $popup = $('[data-popup="' + target + '"]');

            if ($popup.length <= 0) return;

            $popup.toggleClass('opened');

            if($popup.hasClass('opened')) $('body').addClass('popup-opened');
            else $('body').removeClass('popup-opened');
        });
    },
    /**
     * 페이지의 지정한 위치로 이동한다.
     * @param offset    이동할 위치 (default: 0)
     * @param animationTime 이동 시간 (default:300 ms)
     */
    animateToOffset : function (offset, animationTime) {
        animationTime = typeof animationTime != 'undefined' && animationTime ? animationTime : 300;
        offset = typeof offset != 'undefined' && offset ? offset : 0;
        $('html,body').animate({
            scrollTop: offset
        }, animationTime);
    },

    initAnimateScroll: function() {
        var $listItem = $('[data-animate]');
        $listItem.each(function() {
            $(this).addClass('nv');
        });

        $(window).scroll(function() {
            $listItem.each(function(i, el) {
                var $el = $(el);
                if($el.visible(true)) {
                    $el.delay(5000).removeClass('nv');
                } else {
                    $el.addClass('nv');
                }
            });
        }).scroll();
    },

    initDatepicker : function() {
        $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function(inst) {
            $.datepicker._updateDatepicker_original(inst);
            var afterShow = this._get(inst, 'afterShow');
            if (afterShow)
                afterShow.apply((inst.input ? inst.input[0] : null));
        }
        $.datepicker.regional['ko'] = {
            closeText: '닫기',
            prevText: '이전달',
            nextText: '다음달',
            currentText: '오늘',
            monthNames: ['1월','2월','3월','4월','5월','6월', '7월','8월','9월','10월','11월','12월'],
            monthNamesShort: ['1월','2월','3월','4월','5월','6월', '7월','8월','9월','10월','11월','12월'],
            dayNames: ['일','월','화','수','목','금','토'],
            dayNamesShort: ['일','월','화','수','목','금','토'],
            dayNamesMin: ['일','월','화','수','목','금','토'],
            weekHeader: 'Wk',
            dateFormat: 'yy.mm.dd',
            firstDay: 0,
            isRTL: false,
            showMonthAfterYear: true,
            yearSuffix: ''
        };

        $.datepicker.setDefaults($.datepicker.regional['ko']);

        $('[data-toggle="datepicker"]').each(function(){
            $(this).datepicker();
            if( typeof $(this).data('chained-datepicker') != 'undefined' && $(this).data('chained-datepicker') )
            {
                var el = $(this).data('chained-datepicker'),
                    $el = $(el);

                if($el.length > 0 ) {
                    $(this).change(function() {
                        if($el.hasClass('hasDatepicker')) {
                            $el.datepicker('option', 'minDate', $(this).val() );
                        }
                    })
                }
            }
        });

        $("body").on("click", '[data-toggle="datepicker"]', function(){
            if (!$(this).hasClass("hasDatepicker"))
            {
                $(this).datepicker();
                $(this).datepicker("show");
            }
        });
    },

    initInputs: function() {
        /***********************************************************************************************************************
         * 핸드폰 번호 Input
         ***********************************************************************************************************************/
        $('body').on('keypress', '[data-regex="phone-number"]', function(e){
            if (e.which != 8 && e.which != 0 &&  e.which != 45 && (e.which < 48 || e.which > 57)) {
                e.preventDefault();
            }
        }).on('blur','[data-regex="phone-number"]', function(e){
            if($(this).val() == '') return;
            var transNum = $(this).val().regex('phone');
            if( transNum === false ) {
                alert('유효하지 않은 전화번호 입니다.');
                $(this).val("");
                $(this).focus();
                return;
            }
            $(this).val(transNum);
        });

        /***********************************************************************************************************************
         * 전화번호 Input
         ***********************************************************************************************************************/
        $('body').on('blur', '[data-regex="tel-number"]', function(e){
            if($(this).val() == '') return;
            var transNum = $(this).val().regex('tel');
            if( transNum === false ) {
                alert('유효하지 않은 전화번호 입니다.');
                $(this).val("");
                $(this).focus();
                return;
            }
            $(this).val(transNum);
        });

        /***********************************************************************************************************************
         * 이메일주소 Input
         ***********************************************************************************************************************/
        $('body').on('blur', '[data-regex="email-address"]', function(e){
            if($(this).val() == '') return;
            var trans_num = $(this).val().regex('email');

            if(! trans_num) {
                alert('유효하지 않은 이메일주소 입니다.');
                $(this).val("");
                $(this).focus();
            }
        });
    },
    initMainEventBanner: function() {
        if($('[data-toggle="main-event-banner"]').length > 0) {
            $('[data-toggle="main-event-banner"] .slide').slick({
                variableWidth:true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                touchMove : true, // 손가락 터치시 이동 여부...
                swipe : false, // swipe 여부...
                draggable : false,
                customPaging : function(slider, i) {
                    var title = $(slider.$slides[i]).data('title');
                    return '<span class="pager-dot"> </span>';
                }
            });

            $('[data-toggle="main-event-banner"] [data-toggle="close-banner"]').click(function(e) {
                e.preventDefault();
                $('[data-toggle="main-event-banner"] .slide').slick('unslick');
                $('[data-toggle="main-event-banner"]').remove();
            })
        }
    }
};

$.fn.visible = function(partial) {
    var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop))
};

$(function() {
    Application.init();
    setTimeout(function() {
        $('body.t-school, body.company_introduce').addClass('loaded');
    });
    $(window).scroll(function() {
       if( $(window).scrollTop() > 0 ) {
           $('body').addClass('scrolled');
       }  else {
           $('body').removeClass('scrolled');
       }
    }).scroll();

    $('.tschool-header .main-navigation > li').hover(function() {
        $('.tschool-header').addClass('hover')
    }, function() {
        $('.tschool-header').removeClass('hover')
    })
});
